import { Component, OnInit, ElementRef, HostListener, ChangeDetectorRef, AfterContentChecked, SimpleChanges, ViewChild, Renderer2 } from '@angular/core';
import { ColDef, GridReadyEvent, GridApi, GridOptions, GetRowIdParams } from 'ag-grid-community';
import * as Global from "../Models/constants";
import { SCREEN_SIZE, NetZeroPreferencesGridResults } from '../Models/common.model';
import { TtgaPairingService } from '../Services/ttga-pairing.service';

declare var ReadStaticData;
declare var GetDeleteAlertMessage;
let response: string;
@Component({
    selector: 'netzero-preferences',
    templateUrl: './ttga-pairing.component.html',
    styles: []
})
export class NetZeroPreferencesComponent implements OnInit, AfterContentChecked {
    dropdownSettings: {};
    dropdownList = [];


    public rowData!: any[];
    public gridApi!: GridApi;

    public loadContent: boolean = false;
    public paginationPageSize = 10;
    public domLayout: string = Global.domLayout;
    public noRowsTemplate: string = Global.noRowsTemplate;
    public loadingTemplate: string = Global.loadingTemplate;
    dateErrorMessage: string = Global.dateRangeErrorMessage;
    public SelectedResolutions: any[];
    public startDate: string;
    public endDate: string;
    isRequired: boolean = true;
    isValidDate: boolean = true;
    public pagination: boolean = true;
    // dynamically set row height for all detail grids
    public detailRowAutoHeight = true;
    isSelectMode: boolean = false;
    showLoader: boolean = false;
    showCreateNewButton: boolean = false;
    deleteAlertMessage: string;
    isRowSelected: boolean = false;
    @ViewChild('deleteModal') deleteModal: ElementRef;

    private _TTGAPairingGridResults: NetZeroPreferencesGridResults[];
    get tTGAPairingGridResults(): NetZeroPreferencesGridResults[] {
        return this._TTGAPairingGridResults;
    }
    set tTGAPairingGridResults(value: NetZeroPreferencesGridResults[]) {
        this._TTGAPairingGridResults = value;
    }

    prefix = 'is-';
    size: SCREEN_SIZE;
    sizes = [
        {
            id: SCREEN_SIZE.XS, name: 'xs', css: `d-block d-sm-none`
        },
        {
            id: SCREEN_SIZE.SM, name: 'sm', css: `d-none d-sm-block d-md-none`
        },
        {
            id: SCREEN_SIZE.MD, name: 'md', css: `d-none d-md-block d-lg-none`
        },
        {
            id: SCREEN_SIZE.LG, name: 'lg', css: `d-none d-lg-block d-xl-none`
        },
        {
            id: SCREEN_SIZE.XL, name: 'xl', css: `d-none d-xl-block`
        },
    ];

    @HostListener("window:resize", [])
    private onResize() {
        this.detectScreenSize();
    }

    ngAfterViewInit() {
        this.detectScreenSize();
    }

    ngAfterContentChecked(): void {
        this.cdRef.detectChanges()
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {

        }
    }

    private detectScreenSize() {
        const currentSize = this.sizes.find(x => {
            // get the HTML element
            const el = this.elementRef.nativeElement.querySelector(`.${this.prefix}${x.id}`);

            // check its display property value
            const isVisible = window.getComputedStyle(el).display != 'none';

            if (!isVisible) {
                return false;
            }
            else {
                return isVisible;
            }
        });

        this.dataService.onResize(currentSize.id);
    }

    onSelectionChanged(): void {
        const selectedRows = this.gridApi.getSelectedRows();
        this.isRowSelected = selectedRows.length > 0;
    }

    toggleSelectMode(): void {
        this.isSelectMode = !this.isSelectMode;
        if (!this.isSelectMode && this.gridApi) {
            this.gridApi.deselectAll();
        }
        this.updateGridColumns();
    }

    updateGridColumns(): void {
        if (this.gridApi) {
            let currentColumnDefs = this.getCurrentColumnDefs();
            this.gridApi.setColumnDefs(currentColumnDefs);
        }
    }

    private getCurrentColumnDefs(): ColDef[] {
        let currentColumnDefs = this.size == 0 || this.size == 1 ? this.columnDefsClosed_OnExcluded :
            this.size == 2 || this.size == 3 ? this.columnDefsClosed_OnIncluded :
                this.columnDefs;

        return currentColumnDefs.map(colDef => {
            if (colDef.field === 'checkbox') {
                return { ...colDef, hide: !this.isSelectMode };
            }
            if (colDef.field === 'Status') {
                const maxWidth = this.size == 0 || this.size == 1 ? (this.isSelectMode ? 80 : 123) : (this.isSelectMode ? 100 : 140);
                return { ...colDef, maxWidth };
            }
            return colDef;
        });
    }

    private removeExistingBackdrop(): void {
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
            this.renderer.removeChild(document.body, backdrop);
        }
    }

    closeModal(): void {
        this.renderer.setStyle(this.deleteModal.nativeElement, 'display', 'none');
        this.removeExistingBackdrop();
    }


    deleteSelectedItems(): void {
        this.showLoader = true;
        this.closeModal();
        const selectedNodes = this.gridApi.getSelectedNodes();
        const selectedIds = selectedNodes.map(node => node.data.ID);

        this.dataService.deleteNetZeroMultiplePreferences(selectedIds).subscribe(
            response => {
                if (response) {
                    this.rowData = this.rowData.filter(item => !selectedIds.includes(item.ID));
                    this.showCreateNewButton = this.rowData && this.rowData.length >= 2;
                    this.isSelectMode = !this.isSelectMode;
                    this.cdRef.detectChanges();
                    this.showLoader = false;
                    if (this.rowData.length != 0) {
                        this.gridApi.setRowData(this.rowData);
                        this.updateGridColumns();
                    }
                    else {
                        window.location.reload();
                        this.showLoader = false;
                    }
                }
                else {
                    window.location.reload();
                    this.showLoader = false;
                }
            }
        );
    }

    constructor(public dataService: TtgaPairingService, private elementRef: ElementRef, private cdRef: ChangeDetectorRef, private renderer: Renderer2) {
        this.dataService.onResize$.subscribe(x => {
            response = ReadStaticData();
            this.deleteAlertMessage = GetDeleteAlertMessage();
            this.tTGAPairingGridResults = JSON.parse(response);
            this.showCreateNewButton = this.tTGAPairingGridResults && this.tTGAPairingGridResults.length >= 2;
            this.size = x;
            if (this.size == 0 || this.size == 1) {
                const allColumnIds: string[] = [];
                this.gridOptions.api!.setColumnDefs([]);
                this.gridOptions.api!.setColumnDefs(this.columnDefsClosed_OnExcluded);
                this.gridOptions.columnApi.getAllColumns()!.forEach((column) => {
                    allColumnIds.push(column.getId());
                });
                this.gridOptions.columnApi.autoSizeColumns(allColumnIds, false);
            }
            else if (this.size == 2 || this.size == 3) {
                this.gridOptions.api!.setColumnDefs([]);
                this.gridOptions.api!.setColumnDefs(this.columnDefsClosed_OnIncluded);
                if (this.tTGAPairingGridResults[0]['TTGAType'] != null) {
                    this.gridOptions.columnApi.setColumnVisible('TTGAType', true);
                }
                else {
                    this.gridOptions.columnApi.setColumnVisible('TTGAType', false);
                }
            }
            else {
                if (this.tTGAPairingGridResults[0]['TTGAType'] != null) {
                    this.gridOptions.columnApi.setColumnVisible('TTGAType', true);
                }
                else {
                    this.gridOptions.columnApi.setColumnVisible('TTGAType', false);
                }
                if (this.gridApi != undefined) {
                    this.gridOptions.api!.setColumnDefs([]);
                    this.gridOptions.api!.setColumnDefs(this.columnDefsClosed_OnIncluded);
                }
            }
        });
    }

    ngOnInit(): void {
        (window as any).netzeroPreferencesComponent = this;
    }

    ngOnDestroy(): void {
        (window as any).netzeroPreferencesComponent = null;
    }

    gridOptions: GridOptions = {
        rowClassRules: {
            // apply text red to Status Expired
            'text-danger': function (params) { return params.data.Status === "Expired"; },
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true
    }

    public defaultColDef: ColDef = {
        flex: 1,
    };

    public columnDefs: ColDef[] = [
        { field: 'ID', hide: true, sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc' },
        {
            field: 'Title', resizable: true, sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', tooltipField: 'Title', minWidth: 280, maxWidth: 400, suppressMovable: true
        },
        { field: 'Date', sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', headerName: "Date", minWidth: 100, suppressMovable: true },
        { field: 'Domicile', headerName: "Dom", sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', minWidth: 80, suppressMovable: true },
        { field: 'Seat', sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', minWidth: 80, suppressMovable: true },
        { field: 'NetZero', sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', minWidth: 150, suppressMovable: true },
        {
            field: 'Status', sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', cellRenderer: (params) => {
                let keyData = params.data.ID;
                let status = params.data.Status;
                const statusDisplay = `<span>${status}</span>`;
                if (this.isSelectMode) {
                    return statusDisplay;
                }
                let newLink = `<div style="display: flex;align-items: center;">${statusDisplay}<span class="edit-icon ml-auto  mr-2" data-id="${keyData}" title="Edit"></span><span class="delete-icon" data-id="${keyData}" data-toggle="modal" data-target="#modal-delete-alert" title="Delete"></span></div>`;
                return newLink;
            },
            onCellClicked: function (event) {
                const target = event.event.target as HTMLElement;
                const id = target.dataset.id;
                if (target.classList.contains('edit-icon')) {
                    event.event.preventDefault();
                    redirectToEditPage(id);
                } else if (target.classList.contains('delete-icon')) {
                    event.event.preventDefault();
                    deleteItem(id);
                }
            }, minWidth: 140, suppressMovable: true, cellClass: 'no-border'
        },
        {
            field: 'checkbox',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            hide: true,
            maxWidth: 60,
            cellClass: 'no-border'
        }
    ];

    columnDefsClosed_OnIncluded: ColDef[] = [
        { field: 'ID', hide: true, sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc' },
        {
            field: 'Title', resizable: true, sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', tooltipField: 'Title', minWidth: 180, maxWidth: 350, suppressMovable: true
        },
        { field: 'Date', cellClass: 'locked-col', lockPosition: true, sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', headerName: "Date", minWidth: 90, suppressMovable: true },
        { field: 'Domicile', cellClass: 'locked-col', lockPosition: true, sortable: true, headerName: "Dom", sortingOrder: ['asc', 'desc'], sort: 'desc', minWidth: 30, suppressMovable: true  },
        { field: 'Seat', cellClass: 'locked-col', lockPosition: true, sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', minWidth: 30, suppressMovable: true },
        { field: 'NetZero', cellClass: 'locked-col', lockPosition: true, sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', minWidth: 60, suppressMovable: true },
        {
            field: 'Status', sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', cellRenderer: (params) => {
                let keyData = params.data.ID;
                let status = params.data.Status;
                const statusDisplay = `<span>${status}</span>`;
                if (this.isSelectMode) {
                    return statusDisplay;
                }
                let newLink = `<div style="display: flex;align-items: center;">${statusDisplay}<span class="edit-icon ml-auto  mr-2" data-id="${keyData}" title="Edit"></span><span class="delete-icon" data-id="${keyData}" data-toggle="modal" data-target="#modal-delete-alert" title="Delete"></span></div>`;
                return newLink;
            },
            onCellClicked: function (event) {
                const target = event.event.target as HTMLElement;
                const id = target.dataset.id;
                if (target.classList.contains('edit-icon')) {
                    event.event.preventDefault();
                    redirectToEditPage(id);
                } else if (target.classList.contains('delete-icon')) {
                    event.event.preventDefault();
                    deleteItem(id);
                }
            }, minWidth: 140, suppressMovable: true, cellClass: 'no-border'
        },
        {
            field: 'checkbox',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            hide: true,
            maxWidth: 60,
            cellClass: 'no-border'
        }
    ];
    columnDefsClosed_OnExcluded: ColDef[] = [
        { field: 'Title', minWidth: 213, width: 275, maxWidth: 300, resizable: true, sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', tooltipField: 'Title', suppressMovable: true },
        {
            field: 'Status', sortable: true, sortingOrder: ['asc', 'desc'], sort: 'desc', cellRenderer: (params) => {
                let keyData = params.data.ID;
                let status = params.data.Status;
                const statusDisplay = `<span>${status}</span>`;
                if (this.isSelectMode) {
                    return statusDisplay;
                }
                let marginLeftStyle = status === 'Active' ? 'margin-left: 0.5rem !important;' : '';
                let newLink = `<div style="display: flex;align-items: center;"><span class="mr-2">${status}</span><span class="edit-icon ml-auto  mr-2" style="width: 38px;height: 17px; ${marginLeftStyle};"data-id="${keyData}"></span><span class="delete-icon" style="width: 55px;height: 25px" data-id="${keyData}" data-toggle="modal" data-target="#modal-delete-alert"></span></div>`;
                return newLink;
            },
            onCellClicked: function (event) {
                const target = event.event.target as HTMLElement;
                const id = target.dataset.id;
                if (target.classList.contains('edit-icon')) {
                    event.event.preventDefault();
                    redirectToEditPage(id);
                } else if (target.classList.contains('delete-icon')) {
                    event.event.preventDefault();
                    deleteItem(id);
                }
            }, minWidth: 123, maxWidth: 123, suppressMovable: true, cellClass: 'no-border'
        },
        {
            field: 'checkbox',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            hide: true,
            minWidth: 40,
            cellClass: 'no-border'
        }
    ];

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridApi.setDomLayout("autoHeight");
        response = ReadStaticData();
        this.tTGAPairingGridResults = JSON.parse(response);
        this.rowData = this.tTGAPairingGridResults;
        this.gridApi.setRowData(this.rowData);
        params.api.sizeColumnsToFit();
    }
}

function dateComparator(date1: string, date2: string) {
    var date1Number = monthToComparableNumber(date1);
    var date2Number = monthToComparableNumber(date2);

    if (date1Number == null && date2Number == null) {
        return 0;
    }
    if (date1Number == null) {
        return -1;
    }
    if (date2Number == null) {
        return 1;
    }

    return date1Number - date2Number;
}

// eg 29/08/2004 gets converted to 20040829
function monthToComparableNumber(date: string): number {
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }

    const yearNumber = Number.parseInt(date.substring(6, 10));
    const dayNumber = Number.parseInt(date.substring(3, 5));
    const monthNumber = Number.parseInt(date.substring(0, 2));

    return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

function deleteItem(id) {
    const deleteItemIdInput = document.getElementById('deleteItemId') as HTMLInputElement;
    if (deleteItemIdInput) {
        deleteItemIdInput.value = id.toString();
    }
}

function redirectToEditPage(id) {
    const editUrl = `?action=edit&id=${id}`;
    window.location.href = editUrl;
}